<div class="modal-header border-bottom p-3">
  <h6 id="offcanvasAddUserLabel" class="offcanvas-title">
    {{ "CashPayment" | translate }}
  </h6>
  <button
    type="button"
    class="btn-close-modal btn-icon btn-close"
    (click)="callParent('closeCash')"
    aria-label="Close"
  ></button>
</div>

<div class="modal-body mx-0 flex-grow-0">
  <div class="fourth-box row mx-1">
    <div class="col-12">
      <div id="accordionIcon" class="accordion mt-3 accordion-without-arrow">
        <div class="col-12 cashPaymentAmount position-relative">
          <label class="form-label" for="Amount">
            {{ "amount" | translate }}
          </label>
          <input
            id="Amount"
            type="text"
            class="form-control"
            [(ngModel)]="backendJson.totalPrice"
            (keyup)="checkPayValue()"
            mask="separator.0"
            thousandSeparator=","
          />

          <span class="set-position-rial-prefix">
            {{ "Rial" | translate }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer border-top p-3 justify-content-center">
  <button
    type="submit"
    class="btn btn-primary me-sm-3 me-1 data-submit"
    (click)="savePaymentInfo()"
  >
    {{ "Submit" | translate }}
  </button>
</div>

<app-pcsuccess-modal
  [showModal]="modalSuccessConfirm"
  (parentAction)="parentAction($event)"
>
</app-pcsuccess-modal>
